import { BaseModule } from './base.module';

import Cookies from 'js-cookie';
import '../utilities/cookies-enabler';
import postscribe from 'postscribe';
import { AnimationModule } from '../modules/animation.module';
import { AnalyticsModule } from '../modules/analytics.module';
import { EventDispatchModule } from './event-dispatch.module';
import { DocumentLanguageModule } from './document-language.module';
export class CookieModule extends BaseModule {

	language = 'nl';
	transparencyConsentFrameworkVersion = 2.2;
	// @see https://iabeurope.eu/iab-europe-transparency-consent-framework-policies/
	purposesMap = {
		1: 'Opslaan en/of raadplegen van apparaatinformatie',
		2: 'Beperkte data gebruiken voor advertentieselectie',
		3: 'Profielen maken voor gepersonaliseerde advertenties',
		4: 'Profielen gebruiken voor het selecteren van gepersonaliseerde advertenties',
		5: 'Profielen maken voor het personaliseren van inhoud',
		6: 'Profielen gebruiken voor het kiezen van gepersonaliseerde inhoud',
		7: 'Meten van advertentie succes',
		8: 'Meten van inhoud succes',
		9: 'Publiek beter begrijpen via statistiek of combinaties van data uit verschillende bronnen',
		10: 'Ontwikkelen en verbeteren van diensten',
		11: 'Beperkte data gebruiken om inhoud te selecteren',
	};

	purposesTranslationsMap = {
		'nl': this.purposesMap, // the base
		'en': {
			1: 'Store and/or access information on a device', // Opslaan en/of raadplegen van apparaatinformatie
			2: 'Use limited data to select advertising', // Beperkte data gebruiken voor advertentieselectie
			3: 'Create profiles for personalised advertising', // Profielen maken voor gepersonaliseerde advertenties
			4: 'Use profiles to select personalised advertising', // Profielen gebruiken voor het selecteren van gepersonaliseerde advertenties
			5: 'Create profiles to personalise content', // Profielen maken voor het personaliseren van inhoud
			6: 'Use profiles to select personalised content', // Profielen gebruiken voor het kiezen van gepersonaliseerde inhoud
			7: 'Measure advertising performance', // Meten van advertentie succes
			8: 'Measure content performance', // Meten van content succes
			9: 'Understand audiences through statistics or combinations of data from different sources', // Publiek beter begrijpen via statistic of combinaties van data uit verschillende bronnen
			10: 'Develop and improve services', // Ontwikkelen en verbeteren van diensten
			11: 'Use limited data to select content', // Beperkte data gebruiken om inhoud te selecteren
		},
	};

	identifyingNonFunctionalAdvertisingRelatedPurposes = [
		3,
		4,
		5,
		6,
		7,
		8,
		9
	];

	hasNeededPermissionForIdentifyingNonFunctionalAdvertisingRelatedPurposes = false; // default

	googleTransparenceAndConsentFrameworkApplicationProgrammingInterfaceUsed = false;

	initializedFallback = false;

	// the choices just in memory while the page is open
	cachedAllowed = [];

	constructor() {
		super();
		this.analyticsModule = new AnalyticsModule();
		if (typeof this.configurationOverride === 'undefined') {
			this.configurationOverride = {};
		}
	}

	initialize() {
		this.addGoogleTransparencyAndConsentFrameworkCallbacks();
		this.waitAndFallBack();
	}


	waitAndFallBack() {
		// console.log('waitAndFallBack');
		window.addEventListener('load', () => {
			// console.log('window load event happened');
			this.handleFallback();
			// setTimeout(() => {
			// 	// console.log('timeout happened');
			// 	this.handleFallback();
			// }, 5000);
			this.triggerEventOnElement('cookie-module-loaded', document, { module: this });
		});
	}

	handleFallback() {
		console.log('handleFallback');
		if (typeof document !== 'undefined') {
			let body = document.querySelector('body');
			if (body) {
				if (
					body.classList.contains('no-ads') === true ||
					this.initializedFallback === false
				) {
					this.initializeFallback(); // for non TCF systems (i.e.: not configured yet or disabled ads)
					this.initializedFallback = true;
				}
			}
		}
	}

	addGoogleTransparencyAndConsentFrameworkCallbacks() {
		// Make sure that the properties exist on the window.
		window.googlefc = window.googlefc || {};
		window.googlefc.ccpa = window.googlefc.ccpa || {}
		window.googlefc.callbackQueue = window.googlefc.callbackQueue || [];

		window.googlefc.callbackQueue.push({
			'CONSENT_API_READY': () => {
				console.log('CONSENT_API_READY');
				this.initializedFallback = true;
				__tcfapi('addEventListener', this.transparencyConsentFrameworkVersion, (data, success) => {
					console.log('CONSENT_API_READY...', data, success);
					this.initializedFallback = true;
				});
			},
			'CONSENT_DATA_READY':
				() => __tcfapi('addEventListener', this.transparencyConsentFrameworkVersion, (data, success) => {
					// Do something with consent data value; this callback may be invoked
					// multiple times if user consent selections change.
					// console.log('CONSENT_DATA_READY', data, success);
					// console.log('data.purpose.consents', data.purpose.consents);
					let entries = Object.entries(data.purpose.consents);
					// console.log('data.purpose.consents array', entries);
					this.cachedAllowed = [];
					entries.forEach((consent, i) => {
						// console.log('consent', consent);
						// data.purpose.consents[i];
						console.log('Acceptance status for purpose "', this.purposesMap[consent[0]], '" is: ', consent[1]);
						if (consent[1] === true) {
							this.cachedAllowed.push(parseInt(consent[0].toString()));
						}
					});
					// console.log('cached allowed..:', cachedAllowed);
					// if () {

					// }
					if (typeof window !== 'undefined' && typeof window.__tcfapi !== 'undefined') {
						this.googleTransparenceAndConsentFrameworkApplicationProgrammingInterfaceUsed = true;
					}
					if (this.initializedFallback === false) {
						this.initializeFallback();
						this.initializedFallback = true; // only run once
					}
					this.hasNeededPermissionForIdentifyingNonFunctionalAdvertisingRelatedPurposes =
						this.identifyingNonFunctionalAdvertisingRelatedPurposes.every((i) => { return this.cachedAllowed.includes(i) });
					console.log('hasNeededPermissionForIdentifyingNonFunctionalAdvertisingRelatedPurposes', this.hasNeededPermissionForIdentifyingNonFunctionalAdvertisingRelatedPurposes);
					if (this.hasNeededPermissionForIdentifyingNonFunctionalAdvertisingRelatedPurposes === true) {
						this.triggerEventOnElement('non-functional-cookies-accepted', document, { module: this });
						this.onEnable();
						this.cookiesEnabler.enableCookies();
					} else {
						if (this.hasNeededPermissionForIdentifyingNonFunctionalAdvertisingRelatedPurposes === false) {
							this.configureTransparenceAndConsentFrameworkIframePlaceholderMarkup();
							this.onWindowLoaded();
							this.triggerEventOnElement('cookie-module-loaded', document, { module: this });
						}
					}
				})
		});
	}

	hidePreviousCookieBanner() {
		let bannerSelector = '.' + this.cookiesEnablerConfiguration.bannerClass
		let banner = document.querySelector(bannerSelector);
		if (banner) {
			banner.style.visibility = 'hidden';
		}
	}

	checkForIdentifyingNonFunctionalAdvertisingRelatedPurposes(allowedPurposes) {

	}

	debug() {
		console.log('getAllowAdsStatus()', googlefc.getAllowAdsStatus())
		console.log('getConsentStatus()', googlefc.getConsentStatus())
		console.log('getConsentedProviderIds()', googlefc.getConsentedProviderIds())
		console.log('getDefaultConsentRevocationAttestationText()', googlefc.getDefaultConsentRevocationAttestationText())
		console.log('getDefaultConsentRevocationCloseText()', googlefc.getDefaultConsentRevocationCloseText())
		console.log('getDefaultConsentRevocationText()', googlefc.getDefaultConsentRevocationText())
		console.log('getFloatingToolbarTranslatedMessages()', googlefc.getFloatingToolbarTranslatedMessages())
		console.log('getWhitelistStatus()', googlefc.getWhitelistStatus())
		// console.log('showRevocationMessage()', googlefc.showRevocationMessage())

	}

	initializeFallback() {
		// console.log('initializeFallback');
		this.accepted = false; // no choice made yet
		window.postscribe = postscribe;
		this.cookiesEnablerConfiguration = {
			scriptClass: 'ce-script',
			iframeClass: 'ce-iframe',

			acceptClass: 'ce-accept',
			dismissClass: 'ce-dismiss',
			disableClass: 'ce-disable',

			bannerClass: 'ce-banner',
			bannerHTML:
				`
			<div class="cookie-consent-row fade-element-container">
				<div class="fade-element"></div>

				<div class="cookie-disclosure-column">
					<div class="margin-bottom-20"></div>
					<div class="cookie-notice-heading">Jaarbeurs maakt gebruik van cookies</div>
					<div class="margin-bottom-20"></div>
					<p>
					Jaarbeurs maakt gebruik van functionele, analytische, social media en advertentie-cookies. Op deze manier kunnen wij relevante informatie tonen.
					</p>
					<p>
					Voor de meest relevante content vragen we je akkoord te gaan met advertentie- en social media-cookies. Liever niet? Dan gebruiken we alleen noodzakelijke, statistische en functionele cookies, wat kan resulteren in minder relevante content.
					</p>
					<p>
					Voor meer info over het <a target="_blank" href="https://www.jaarbeurs.nl/documenten/lijst_gebruikte_cookies.pdf">cookiegebruik</a> en de verwerking van jouw persoonsgegevens kijk je in ons <a target="_blank" href="https://www.jaarbeurs.nl/nl/privacy-statement">Privacy Statement</a>.
					</p>
					<div class="hook"></div>
					<div class="margin-bottom-20"></div>
					<div class="cookie-consent-row">
						<div class="cookie-consent-column">
							<div class="cookie-button-column">
							<a href="#" class="cookie-wall-button ce-accept">Accepteren</a>
						</div>
							<div class="cookie-button-column">
								<a href="#" class="cookie-wall-button ce-disable">Weigeren</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			`,

			eventScroll: false,
			scrollOffset: 200,

			clickOutside: false,

			cookieName: 'ckaccept',
			cookieDurationNonFunctional: (365 * 10).toString(),
			cookieDurationFunctional: '1',
			cookieValueMapping: {
				deny: '0',
				allow: '1'
			},
			wildcardDomain: true,

			iframesPlaceholder: true,
			iframesPlaceholderHTML: ` 
			<div>
				<p>Deze embed gebruikt niet-functionele cookies. Accepteer <a href="#" class="ce-accept revoke-cookie-choice">niet-functionele cookies</a> om de embed te tonen.</p>
				<div class="d-flex">
					<p><a class="btn btn-primary ce-accept revoke-cookie-choice">Accepteer niet-functionele cookies</a></p>
				</div>
			</div>`,
			iframesPlaceholderClass: 'ce-iframe-placeholder',

			// Callbacks
			onEnable: () => {
				this.onEnable();
			},
			onDismiss: () => {
				this.onDismiss();
			},
			onDisable: () => {
				this.onDisable();
			},
			sendAcceptanceDataToAnalyticsPlatform: true
		}
		this.animationModule = new AnimationModule();
		this.normalizeCookieAcceptanceCookieValue();
		this.createLanguageSpecificBannerMarkup();
		if (this.googleTransparenceAndConsentFrameworkApplicationProgrammingInterfaceUsed === true) {
			this.configureTransparenceAndConsentFrameworkIframePlaceholderMarkup();
		}
		this.mergeDefaultConfigurationWithConfigurationOverride();
		// console.log(this.cookiesEnablerConfiguration);

		// if (typeof window !== 'undefined') {
		// window.addEventListener('load', () => {
		this.onWindowLoaded();
		// })
		// }
	}

	configureTransparenceAndConsentFrameworkIframePlaceholderMarkup() {
		this.cookiesEnablerConfiguration.iframesPlaceholderHTML = `<p>Deze embed gebruikt mogelijk niet-functionele cookies. Om deze embed te tonen kun je <a href="#" class="revoke-cookie-choice">niet-functionele cookies accepteren</a> <p>`;
		if (this.googleTransparenceAndConsentFrameworkApplicationProgrammingInterfaceUsed === true) {
			// console.log('cached allowed array', this.cachedAllowed);
			let humanReadableAcceptedPurposes = [];
			this.identifyingNonFunctionalAdvertisingRelatedPurposes.forEach((consent, i) => {
				// console.log('consent entry', consent, 'at i', i);
				if (
					typeof this.purposesTranslationsMap[this.language] !== 'undefined' &&
					typeof this.purposesTranslationsMap[this.language][consent] !== 'undefined'
				) {
					humanReadableAcceptedPurposes.push(`<li>${this.purposesTranslationsMap[this.language][consent]}</li>`);
				}
			});
			let markup = humanReadableAcceptedPurposes.join('');
			markup = `Deze embed gebruikt mogelijk de volgende doelstellingen: <ul>${markup}</ul>`;
			this.cookiesEnablerConfiguration.iframesPlaceholderHTML = `${this.cookiesEnablerConfiguration.iframesPlaceholderHTML} ${markup}`;
		}
		
		this.cookiesEnablerConfiguration.iframesPlaceholderHTML = `${this.cookiesEnablerConfiguration.iframesPlaceholderHTML} <div class="d-flex"><p><a class="btn btn-primary ce-accept revoke-cookie-choice">Accepteer niet-functionele cookies</a></p></div>`;
	}

	mergeDefaultConfigurationWithConfigurationOverride() {
		this.cookiesEnablerConfiguration = Object.assign(this.cookiesEnablerConfiguration, this.configurationOverride);
	}

	onWindowLoaded() {
		this.initializeCookiesEnabler();
		this.addEventListeners();
	}

	addEventListeners() {
		let revocationElements = document.querySelectorAll('.revoke-cookie-choice');
		if (revocationElements) {
			revocationElements.forEach((revocationElement) => {
				revocationElement.addEventListener('click', (event) => {
					if (typeof window !== 'undefined' && typeof window.googlefc !== 'undefined' && typeof window.googlefc.showRevocationMessage !== 'undefined') {
						window.googlefc.showRevocationMessage();
						// reset the permission
						this.cachedAllowed = [];
						this.hasNeededPermissionForIdentifyingNonFunctionalAdvertisingRelatedPurposes = false;
						this.triggerEventOnElement('revoke-cookie-choice', document, { module: this });
					}
				});
			});
		}
	}

	overrideConfigurationWithEnglishMarkup() {
		this.setConfigurationOverride({
			bannerHTML: `
			<div class="cookie-consent-row fade-element-container">
				<div class="fade-element"></div>
				<div class="cookie-disclosure-column">
					<div class="margin-bottom-20"></div>
					<div class="cookie-notice-heading">Jaarbeurs uses cookies</div>
					<div class="margin-bottom-20"></div>
					<p>
					Jaarbeurs uses functional, analytical, social media, and advertising cookies. This allows us to display relevant information.
					</p>
					<p>
					For the most relevant content, we ask for your consent to use advertising and social media cookies. Prefer not to? In that case, we will only use necessary, statistical, and functional cookies, which may result in less relevant content.
					</p>
					<p>
					For more information about <a href="https://www.jaarbeurs.nl/documenten/lijst_gebruikte_cookies.pdf">cookie usage</a> and the processing of your personal data, please refer to our <a target="_blank" href="https://www.jaarbeurs.nl/en/privacy-statement">Privacy Statement</a>.
					</p>
					<div class="margin-bottom-20"></div>
					<div class="cookie-consent-row">
						<div class="cookie-consent-column">
							<div class="cookie-button-column">
								<a href="." class="cookie-wall-button ce-accept">Accept</a>
							</div>
							<div class="cookie-button-column">
								<a href="." class="cookie-wall-button ce-disable">Refuse</a>
							</div>
						</div>
					</div>
				</div>
			</div>`,
			iframesPlaceholderHTML: ` 
			<p>This embed uses non-functional cookies. To be able to see this embed you need to <a href="#" class="ce-accept revoke-cookie-choice">accept non-functional cookies</a></p>`,

		});
	}

	createLanguageSpecificBannerMarkup() {
		let languageModule = new DocumentLanguageModule();
		let language = languageModule.guessLanguageFromUri();
		if (language === null) {
			language = languageModule.guessLanguageFromHtmlLanguage();
		}
		// console.log('language', language);
		if (language) {
			switch (language) {
				case 'en':
					this.overrideConfigurationWithEnglishMarkup();
					break;
			}
		}
	}

	setLanguage(language) {
		this.language = language;
	}

	initializeCookiesEnabler() {
		// console.log('initializeCookiesEnabler');
		if (typeof window !== 'undefined' && typeof document !== 'undefined') {
			document.addEventListener('cookie-module-loaded', () => {
				document.querySelectorAll('.ce-accept').forEach((acceptanceLink) => {
					acceptanceLink.addEventListener('click', (event) => {
						event.preventDefault(); // prevent # nav
						this.onEnable();
						if (this.googleTransparenceAndConsentFrameworkApplicationProgrammingInterfaceUsed === false) {
							this.cookiesEnabler.enableCookies();
						}
					});
				});
			});
			this.cookiesEnabler = window.COOKIES_ENABLER;
			window.COOKIES_ENABLER.init(this.cookiesEnablerConfiguration);
			// console.log('COOKIES_ENABLER', window.COOKIES_ENABLER);
			let bannerSelector = '.' + this.cookiesEnablerConfiguration.bannerClass
			let banner = document.querySelector(bannerSelector);
			if (banner) {
				banner.style.visibility = 'hidden';
				if (typeof window !== 'undefined' && typeof window.__tcfapi === 'undefined') {
					this.animationModule.autoHeightAnimate(banner, 400, (element) => {
						element.classList.add('animation-done');
					});
				}
			}
		}
	}

	onEnable() {
		this.accepted = true;
		if (
			typeof this.cookiesEnablerConfiguration.sendAcceptanceDataToAnalyticsPlatform !== 'undefined' &&
			this.cookiesEnablerConfiguration.sendAcceptanceDataToAnalyticsPlatform === true
		) {
			this.analyticsModule.getAllGoogleAnalyticsInstances().forEach(googleAnalyticsInstance => {
				let analyticsEventData = {
					'eventCategory': 'Cookiemelding',
					'eventAction': 'Keuze',
					'eventLabel': 'Ja'
				}
				googleAnalyticsInstance.send('event', analyticsEventData);
			});
		}
		if (typeof document !== 'undefined') {
			// this.hasNeededPermissionForIdentifyingNonFunctionalAdvertisingRelatedPurposes = true;
			this.triggerEventOnElement('non-functional-cookies-accepted', document, { module: this });
		}
	}

	onDismiss() {
	}

	onDisable() {
		this.accepted = false;
		if (
			typeof this.cookiesEnablerConfiguration.sendAcceptanceDataToAnalyticsPlatform !== 'undefined' &&
			this.cookiesEnablerConfiguration.sendAcceptanceDataToAnalyticsPlatform === true
		) {
			this.analyticsModule.getAllGoogleAnalyticsInstances().forEach(googleAnalyticsInstance => {
				let analyticsEventData = {
					'eventCategory': 'Cookiemelding',
					'eventAction': 'Keuze',
					'eventLabel': 'Nee'
				}
				googleAnalyticsInstance.send('event', analyticsEventData);
			});
		}
	}

	normalizeCookieAcceptanceCookieValue() {
		let accepted = Cookies.get(this.cookiesEnablerConfiguration.cookieName);
		if (accepted) {
			accepted = parseInt(accepted, 10); // cast to decimal number
			switch (accepted) {
				case 0:
					this.accepted = false;
					break;
				case 1:
					this.accepted = true;
					break;
				default:
					this.accepted = false;
			}
		}
	}
	areCookiesAccepted() {
		return this.accepted;
	}

	setConfigurationOverride(configurationOverride) {
		this.configurationOverride = configurationOverride;
	}
}
